import { useMutation, useQuery } from "react-query";
import useInvitations from "../../common/hooks/pages/useInvitations";
import { usePopup } from "../../common/contexts/PopupContext";
import { validatePassword } from "../../common/helpers/common";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import { useNavigate } from "react-router-dom";
import ApiValidate from "../../common/components/ApiValidate";
import { setLocalStorage } from "../../common/helpers/browserStorage";
import { useAuth } from "../../common/contexts/AuthContext";
import { useApp } from "../../common/contexts/AppContext";

function getFormInputs(email) {
  return [
    {
      type: "text",
      label: "Email",
      name: "email",
      placeholder: "name@example.com",
      validation: {
        required: "Email is required",
        pattern: {
          value: /^\S+@\S+$/,
          message: "Invalid email address",
        },
      },
      defaultValue: email,
      disabled: true,
    },
    {
      type: "text",
      name: "userName",
      label: "Full name",
      placeholder: "Full name",
      validation: {
        required: "Full name is required",
      },
    },
    {
      type: "password",
      label: "Password",
      name: "password",
      placeholder: "Enter at least 8 characters",
      validation: {
        required: "Password is required",
        validate: validatePassword,
      },
    },
  ];
}

function CheckInvitationContainer() {
  const { checkInvitation, acceptInvitation, registerInvitedUser } =
    useInvitations();

  const { toast } = usePopup();

  const { setAccessToken } = useAuth();

  const { organizationId, setOrganizationId } = useApp();

  const { mutate: acceptInvitationMutate, isLoading: isAccepting } =
    useMutation({
      mutationFn: acceptInvitation,
      onSuccess: (res) => {
        const { message, organizationId: orgId } = res?.data || {};

        if (!organizationId) {
          setOrganizationId(orgId);
          setLocalStorage("organizationId", orgId);
        }

        toast(message, "success");

        window.location.href = window.location.origin + "/pages";
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          "Something went wrong while accepting invitation!";
        toast(message, "error");
      },
    });

  const { mutate: registerInvitedUserMutate, isLoading: isRegistering } =
    useMutation({
      mutationFn: registerInvitedUser,
      onSuccess: (res) => {
        const { message, accessToken } = res?.data || {};

        setLocalStorage("accessToken", accessToken);
        setAccessToken(accessToken);

        toast(message, "success");
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          "Something went wrong while registering!";
        toast(message, "error");
      },
    });

  const { data, isError, isLoading } = useQuery({
    retry: false,
    queryKey: "checkInvitation",
    queryFn: checkInvitation,
    onSuccess: (res) => {
      const { isExistingUser } = res?.data;

      if (isExistingUser) {
        acceptInvitationMutate();
      }
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while checking invitation token!";
      toast(message, "error");
    },
  });

  const { isExistingUser, email } = data?.data || {};

  return (
    <div className="bg-gradient-to-r from-purple-900 to-purple-500 h-screen flex flex-col justify-center items-center">
      <div className="bg-white rounded-md shadow-md p-8 text-gray-700 md:w-[450px]">
        <div className="font-bold text-center mb-8 text-2xl font-bold">
          Invitation {isAccepting ? "(Accepting...)" : null}
        </div>

        <ApiValidate isError={isError} isLoading={isLoading}>
          {isExistingUser ? null : (
            <FormBuilder
              formInputs={getFormInputs(email)}
              submitButtonLabel="Register"
              onSubmit={(data) => {
                const payload = { ...data };

                delete payload.email;

                registerInvitedUserMutate(payload);
              }}
              isSubmitting={isRegistering}
            />
          )}
        </ApiValidate>
      </div>
    </div>
  );
}

export default CheckInvitationContainer;
